"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TechTrackerCms = void 0;
var TechTrackerCms = /** @class */ (function () {
    function TechTrackerCms() {
        this.trackHeading = 'Track your tech in real time!';
        this.trackMessage = 'Just be sure to give us a good mobile number.';
        this.trackTooltip = "On the day of installation, we'll send  you a text message\n    with a link to track your technician. We'll also let you know your tech's contact\n    info and estimated arrival time.";
    }
    return TechTrackerCms;
}());
exports.TechTrackerCms = TechTrackerCms;
//# sourceMappingURL=TechTracker.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/components/panels/ScheduleInstallPanel/TechTracker/TechTracker.cms.js
// module id = 970
// module chunks = 8